import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LegendItem } from "app/shared/data-interaction";
import { Helper } from "app/shared/helper";
import { Logger } from "app/shared/services/logger.service";
import { Chart } from "chart.js";

@Component({
  selector: "app-needs-covered-dhn",
  templateUrl: "./needs-covered-dhn.component.html",
  styleUrls: ["./needs-covered-dhn.component.css"]
})
export class NeedsCoveredDhnComponent implements OnInit {
  @ViewChild("chartNeedsCoveredDhn") canvas;
  @Input() type;
  @Input() chart_id;
  @Input() options;
  @Input() indicator;
  @Input() sample_data;
  @Input() chartData;
  @Input() value_type;
  @Input() unit;
  @Input() show_network_mix;

  private yAxeLabel: String;
  private yAxeLabel_right: String;
  //To change or improve
  private chart: Chart;
  public parkingSpacesData: any;
  private areaChartDatasets;
  private yAxes;
  private legendItems: LegendItem[] = [];

  constructor(
    private helper: Helper,
    private translateService: TranslateService
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    this.createMinergieChart();
    this.updateLegend();
  }

  getTranslatedLabel(labelToTranslate) {
    return this.translateService.instant("DATA." + labelToTranslate);
  }

  createMinergieChart() {
    this.resetChart();
    if (this.sample_data) {
      this.parkingSpacesData = this.getSampleData();
    } else {
      if (this.chartData) {
        this.yAxeLabel = this.translateService.instant(
          `DASHBOARD.CHARTS.${this.chart_id}.LEFT_Y_LABEL_NAME`
        );
        this.yAxeLabel_right = this.translateService.instant(
          `DASHBOARD.CHARTS.${this.chart_id}.RIGHT_Y_LABEL_NAME`
        );
        this.yAxeLabel_right += this.translateService.instant(
          `UNITS.percentage.pct`
        );
        this.parkingSpacesData = { labels: this.chartData["labels"] };
        this.parkingSpacesData["datasets"] = this.chartData["datasets"];
        /* this.yAxeLabel += this.translateService.instant(
            `UNITS.${unit_from_config["translate_unit"]}`
          ); */
        this.options["scales"]["yAxes"][0]["scaleLabel"][
          "labelString"
        ] = this.yAxeLabel;
        var i;
        for (i = 0; i < this.parkingSpacesData["datasets"].length; i++) {
          this.parkingSpacesData["datasets"][i][
            "label"
          ] = this.getTranslatedLabel(
            this.parkingSpacesData["datasets"][i]["label"]
          );
        }
      }
    }
    // Define behavior of tooltip label for the chart
    this.options.tooltips.callbacks.label = (item, data) => {
      return [
        `${data.datasets[item.datasetIndex]
          .label} : ${this.helper.getThousandSeparatorFromNumber(item.yLabel)} `
      ];
    };
    this.options.responsive = true;
    const ctx = this.canvas.nativeElement.getContext("2d");
    /* if (this.display_option == "stacked"){
        this.options.scales.yAxes[0].stacked = true;
      } */
    this.options["maintainAspectRatio"] = false;
    this.options.legend.display = false;
    this.yAxes = [
      {
        id: "left",
        position: "left",
        type: "linear",
        scaleLabel: {
          display: true,
          labelString: this.yAxeLabel,
          fontColor: "black",
          fontSize: 14
        },
        ticks: {
          beginAtZero: true
        }
      },
      {
        id: "right",
        position: "right",
        type: "linear",
        scaleLabel: {
          display: true,
          labelString: this.yAxeLabel_right,
          fontColor: "black",
          fontSize: 14
        },
        ticks: {
          beginAtZero: true
        }
      }
    ];
    this.options.scales.yAxes = this.yAxes;
    this.chart = new Chart(ctx, {
      type: this.type,
      data: this.parkingSpacesData,
      options: this.options
    });
  }

  resetChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = void 0;
    }
  }

  updateLegend() {
    this.legendItems = [];
    if (this.chart) {
      // legend element is corresponds to each dataset and its color
      this.chart.data.datasets.forEach(dataset => {
        const legendItem: LegendItem = {
          label: dataset.label,
          color: dataset.backgroundColor,
          borderColor: dataset.borderColor
            ? dataset.borderColor
            : dataset.backgroundColor,
          borderStyle: dataset.borderColor ? "solid" : "none",
          clicked: false,
          datasetIndices:[]
        };

        this.legendItems.push(legendItem);
      });
    }
  }

  onLegendClick(legendIndex: number) {
    let clickedDataset = this.chart.data.datasets[legendIndex];
    clickedDataset.hidden = !clickedDataset.hidden;
    this.chart.update();
  }

  getSampleData() {
    let networksChartLabels = [2017, 2018, 2019, 2020];
    let gazData = [104490000, 98973204, 92026299, 90000000];
    let dhnData = [4500000, 5475000, 6450000, 8250000];
    var dcnData = [0, 10000000, 50000000, 50000000];

    var sampleData = {
      labels: networksChartLabels
    };
    if (!this.show_network_mix) {
      this.areaChartDatasets = [
        {
          label: "Réseau de gaz",
          data: gazData,
          stack: "gaz",
          backgroundColor: "rgba(50, 50, 50, 0.3)",
          borderColor: "rgba(50, 50, 50)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "Réseaux CAD",
          data: dhnData,
          stack: "dhn",
          backgroundColor: "rgba(164, 24, 211, 0.3)",
          borderColor: "rgba(164, 24, 211)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        }
      ];
    } else if (this.show_network_mix) {
      this.areaChartDatasets = [
        {
          label: "Gaz - Gaz naturel",
          data: gazData.map(function(x) {
            return x * 0.95;
          }),
          stack: "gaz",
          backgroundColor: "rgba(50, 50, 50, 0.3)",
          borderColor: "rgba(50, 50, 50)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "Gaz - Biogaz",
          data: gazData.map(function(x) {
            return x * 0.05;
          }),
          stack: "gaz",
          backgroundColor: "rgba(204, 153, 51, 0.3)",
          borderColor: "rgba(204, 153, 51)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "CAD - Bois",
          data: dhnData.map(function(x) {
            return x * 0.5;
          }),
          stack: "dhn",
          backgroundColor: "rgba(153, 102, 51, 0.3)",
          borderColor: "rgba(153, 102, 51)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "CAD - Gaz",
          data: dhnData.map(function(x) {
            return x * 0.2;
          }),
          stack: "dhn",
          backgroundColor: "rgba(50, 50, 50, 0.3)",
          borderColor: "rgba(50, 50, 50)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "CAD - PAC",
          data: dhnData.map(function(x) {
            return x * 0.3;
          }),
          stack: "dhn",
          backgroundColor: "rgba(51, 204, 153, 0.3)",
          borderColor: "rgba(51, 204, 153)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "FAD - Eau lac",
          data: dcnData.map(function(x) {
            return x * 0.9;
          }),
          stack: "dhn",
          backgroundColor: "rgba(0, 153, 204, 0.3)",
          borderColor: "rgba(0, 153, 204)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "FAD - Elec",
          data: dcnData.map(function(x) {
            return x * 0.1;
          }),
          stack: "dhn",
          backgroundColor: "rgba(0, 51, 153, 0.3)",
          borderColor: "rgba(0, 51, 153)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        }
      ];
    }
    sampleData["datasets"] = this.areaChartDatasets;
    return sampleData;
  }
}
